export const t = {
  en: {
    logo: 'MyGlow', logoSub: 'your glow, saved',
    tagline: 'Your glow,', taglineGold: 'kept by people', taglineEnd: 'who love you',
    subtitle: 'Share your link. Friends leave anonymous notes. Open your jar when you need a lift.',
    signUp: 'Create account', logIn: 'Log in', logOut: 'Log out',
    email: 'Email address', password: 'Password', name: 'Your first name',
    namePlaceholder: 'e.g. Sara', emailPlaceholder: 'you@example.com',
    passwordPlaceholder: 'At least 8 characters',
    createAccount: 'Create my jar ✨', loginBtn: 'Open my jar',
    forgotPassword: 'Forgot password?', resetPassword: 'Send reset link',
    resetSent: 'Check your email for the reset link!',
    noAccount: "Don't have an account?", hasAccount: 'Already have an account?',
    getJar: 'Get my jar ✨', freeHint: 'Free · Secure · Anonymous sending',
    myJar: 'My jar', sendGlow: '✍️ Send a glow',
    glowSent: 'Glow sent! ✨', glowSentSub: "Your anonymous message is sealed in their jar. They'll open it when they need it most.",
    backToGlow: 'Back to my jar', getOwn: 'Create my own myglow.me',
    addToJar: 'Add a glow to their jar ✨',
    writePlaceholder: 'Write something warm… what do you love about them? What would you want them to know?',
    inspireMe: '✦ Inspire me', sendBtn: 'Add to their jar ✨',
    anonymous: '100% anonymous — always',
    getOwn2: 'Want your own jar?', createFree: 'Create yours free →',
    jarTitle: "'s Jar 🫙", newGlows: 'new glow', newGlowsPlural: 'new glows',
    allCaughtUp: '✓ all caught up',
    jarEmpty: 'Your jar is empty — share your link!', jarFull: '% full',
    glowsCollected: 'glows collected', fillsTo: '· fills up to 10',
    shareLink: 'Your link — share it with people who care 💛',
    copyLink: 'Copy link', copied: 'Copied! ✓',
    emptyJarTitle: 'Your jar is waiting…',
    emptyJarSub: 'Share your link above and let people fill it with glows.',
    anonGlow: 'anonymous glow', justNow: 'just now',
    mAgo: 'm ago', hAgo: 'h ago', dAgo: 'd ago',
    loading: 'Loading…', notFound: "This jar doesn't exist 🫙",
    notFoundSub: 'Check the link or create your own.',
    error: 'Something went wrong. Please try again.',
    authError: 'Wrong email or password. Please try again.',
    weakPassword: 'Password must be at least 8 characters.',
    emailInUse: 'An account with this email already exists.',
    howTitle: 'How does it work?',
    how1Title: 'Create your jar', how1Sub: 'Sign up and get your personal link in seconds',
    how2Title: 'Share your link', how2Sub: 'Send it to friends and family on WhatsApp or Instagram',
    how3Title: 'Open your glows', how3Sub: 'When you need a lift, open your jar and feel the love',
    whyTitle: 'Why MyGlow?',
    why1: '🔒 100% anonymous', why1sub: "You'll never know who sent what",
    why2: '💛 Always there', why2sub: 'Your jar waits for you whenever you need it',
    why3: '🌍 Arabic & English', why3sub: 'Switch language anytime',
    dir: 'ltr', font: "'Outfit', sans-serif",
    displayFont: "'Playfair Display', serif",
  },
  ar: {
    logo: 'MyGlow', logoSub: 'ضوّك، متحفظ',
    tagline: 'ضوّك،', taglineGold: 'محفوظ عند', taglineEnd: 'اللي بيحبوك',
    subtitle: 'شارك اللينك بتاعك. صحابك يسيبولك رسايل مجهولة. افتح جرّتك لما تحتاج دفا.',
    signUp: 'عمل حساب', logIn: 'دخول', logOut: 'خروج',
    email: 'الإيميل', password: 'كلمة السر', name: 'اسمك الأول',
    namePlaceholder: 'مثلاً: سارة', emailPlaceholder: 'إيميلك@مثال.com',
    passwordPlaceholder: '٨ حروف على الأقل',
    createAccount: 'عمل جرّتي ✨', loginBtn: 'افتح جرّتي',
    forgotPassword: 'نسيت كلمة السر؟', resetPassword: 'ابعتلي رابط استعادة',
    resetSent: 'اتحقق من إيميلك!',
    noAccount: 'معندكش حساب؟', hasAccount: 'عندك حساب بالفعل؟',
    getJar: 'عمل جرّتي ✨', freeHint: 'مجاني · آمن · الإرسال مجهول',
    myJar: 'جرّتي', sendGlow: '✍️ ابعت ضو',
    glowSent: 'اتبعت! ✨', glowSentSub: 'رسالتك المجهولة وصلت لجرّتهم. هيفتحوها لما يحتاجوها.',
    backToGlow: 'ارجع لجرّتي', getOwn: 'عمل myglow.me بتاعتك',
    addToJar: 'ضيف ضو لجرّتهم ✨',
    writePlaceholder: 'اكتب حاجة حلوة… بتحبهم ليه؟ عايزهم يعرفوا إيه؟',
    inspireMe: '✦ وهّمني', sendBtn: 'ضيف لجرّتهم ✨',
    anonymous: '١٠٠٪ مجهول — دايماً',
    getOwn2: 'عايز جرّتك الخاصة؟', createFree: 'عملها مجاناً ←',
    jarTitle: ' جرّة', newGlows: 'ضو جديد', newGlowsPlural: 'أضواء جديدة',
    allCaughtUp: '✓ كل حاجة اتقرأت',
    jarEmpty: 'جرّتك فاضية — شارك اللينك!', jarFull: '٪ ممتلية',
    glowsCollected: 'أضواء اتجمعت', fillsTo: '· بتتملى لحد ١٠',
    shareLink: 'اللينك بتاعك — شاركه مع اللي بيهتموا بيك 💛',
    copyLink: 'نسخ اللينك', copied: 'اتنسخ! ✓',
    emptyJarTitle: 'جرّتك بتستناك…',
    emptyJarSub: 'شارك اللينك وخلي الناس تملّيها بأضواء.',
    anonGlow: 'ضو مجهول', justNow: 'دلوقتي',
    mAgo: 'د', hAgo: 'س', dAgo: 'ي',
    loading: 'شوية…', notFound: 'الجرّة دي مش موجودة 🫙',
    notFoundSub: 'اتحقق من اللينك أو عمل جرّتك الخاصة.',
    error: 'حصل غلطة. حاول تاني.',
    authError: 'الإيميل أو كلمة السر غلط.',
    weakPassword: 'كلمة السر لازم تكون ٨ حروف على الأقل.',
    emailInUse: 'في حساب بالإيميل ده بالفعل.',
    howTitle: 'بيشتغل إزاي؟',
    how1Title: 'عمل جرّتك', how1Sub: 'سجّل وانت عندك لينك خاص بيك في ثانية',
    how2Title: 'شارك اللينك', how2Sub: 'ابعته لصحابك وأهلك على واتساب أو انستجرام',
    how3Title: 'افتح الأضواء', how3Sub: 'لما تحس إنك محتاج دفا، افتح جرّتك واتبسط',
    whyTitle: 'ليه MyGlow؟',
    why1: '🔒 مجهول تماماً', why1sub: 'مش هتعرف مين بعتلك',
    why2: '💛 دايماً موجود', why2sub: 'جرّتك بتستناك في أي وقت',
    why3: '🌍 بالعربي والإنجليزي', why3sub: 'اختار اللغة اللي تريحك',
    dir: 'rtl', font: "'Tajawal', sans-serif",
    displayFont: "'Tajawal', sans-serif",
  }
};

export const PROMPTS = {
  en: [
    "You make every room brighter just by walking in.",
    "I think about your kindness more than you know.",
    "The world is genuinely better because you exist in it.",
    "You are stronger than the thing you're worried about right now.",
    "Someone out there is so glad you never gave up.",
    "Your laugh is one of the best sounds I've ever heard.",
    "You deserve every beautiful thing coming your way.",
    "I hope you're as proud of yourself as I am of you.",
  ],
  ar: [
    "تُضيء كل غرفة تدخلها بمجرد حضورك.",
    "أفكر في لطفك أكثر مما تتخيل.",
    "العالم أجمل لأنك موجود فيه.",
    "أنت أقوى مما تخشاه الآن.",
    "هناك من يشكر الله كل يوم لأنك لم تستسلم.",
    "ضحكتك من أجمل الأصوات التي سمعتها.",
    "تستحق كل الجميل القادم إليك.",
    "أتمنى أن تكون فخوراً بنفسك بقدر فخري بك.",
  ]
};

export const EMOJIS = ["✨", "🌟", "💛", "🌸", "🫂", "🕊️", "🌈", "💌", "🌻", "🔥"];
